// extracted by mini-css-extract-plugin
export default {"switch_simples_container":"styles_switch_simples_container__Lbo1g"};